import { get, post } from "./requests";
import qs from 'query-string';

export function ratePercyChat({ helpful, contact_requested, note, transcript }) {
  return post('/owner/v2/ai/rate', { helpful, contact_requested, note, transcript }).then(res => res.json());
}

export function getAIInitialSummary() {
  return get("/owner/v1/ai/initial_summary").then(res => res.json());
}

export function getAIExpandedSummary() {
  return get("/owner/v1/ai/expanded_summary").then(res => res.json());
}
export function getAILogs() {
  return get("/owner/v1/ai/logs").then(res => res.json());
}

export function getQuestions() {
  return get("/owner/v1/ai/questions").then(res => res.json());
}

export function askQuestion(question) {
  return post("/owner/v1/ai/ask", { question }).then(res => res.json());
}

export function getAILogsv2(page) {
  const url = qs.stringifyUrl({
    url: '/owner/v2/ai/logs',
    query: {
      page: page,
    },
    skipNull: true,
  });
  return get(url).then(res => res.json());
}

export function askQuestionv2(message) {
  return post("/owner/v2/ai/ask", { message }).then(res => res.json());
}

export function getAIInitialSummaryv2() {
  return get("/owner/v2/ai/initial_summary").then(res => res.json());
}

/**
 * Stream a question to Percy via SSE.
 * Step 1: Call Rails to create the log and get Percy connection details.
 * Step 2: Stream directly from brb-percy (bypasses Rails proxy for smooth streaming).
 * Step 3: Save the completed answer back to Rails.
 */
export function streamQuestion(message, { onToken, onDone, onError }) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

  // Step 1: Prepare — get Percy URL, key, user data, and log ID from Rails
  fetch('/owner/v2/ai/prepare_stream', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify({ message }),
  }).then(res => {
    if (!res.ok) {
      onError('Failed to prepare stream');
      return;
    }
    return res.json();
  }).then(prepData => {
    if (!prepData) return;

    const { log_id, percy_url, percy_key, payload } = prepData;

    // Step 2: Stream directly from brb-percy
    fetch(percy_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${percy_key}`,
      },
      body: JSON.stringify(payload),
    }).then(response => {
      if (!response.ok) {
        onError('Failed to connect to Percy');
        return;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let fullAnswer = '';

      function read() {
        reader.read().then(({ done, value }) => {
          if (done) return;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop();

          for (const line of lines) {
            if (!line.startsWith('data: ')) continue;
            try {
              const data = JSON.parse(line.slice(6));
              if (data.type === 'token') {
                fullAnswer += data.text;
                onToken(data.text);
              } else if (data.type === 'done') {
                // Step 3: Save answer to Rails, then notify caller
                fetch('/owner/v2/ai/save_answer', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify({ log_id, answer: fullAnswer }),
                }).then(() => {
                  onDone({ id: log_id, answer: fullAnswer });
                });
              } else if (data.type === 'error') {
                onError(data.error);
              }
            } catch (e) {
              // skip malformed data
            }
          }

          read();
        }).catch(err => {
          onError(err.message);
        });
      }

      read();
    }).catch(err => {
      onError(err.message);
    });
  }).catch(err => {
    onError(err.message);
  });
}
